const initialState = {
  status: "invalid",
  data: null,
};

export default (state = initialState, action) => {
  switch (action.type) {
    case "BRAND_LABEL_LOADING":
      return {
        ...state,
        status: "loading",
      };
    case "BRAND_LABEL_SUCCESS":
      return {
        ...state,
        status: "success",
        data: action.data,
      };
    case "BRAND_LABEL_FAILURE":
      return {
        ...state,
        status: "failure",
      };
    default:
      return state;
  }
};
